import RenderersSetup from './renderers/PluginSetup';
import AttributesSetup from './attributes/PluginSetup';
import FiltersSetup from './filters/PluginSetup';
const FIELD_NAMES = ['year', 'make', 'model'];
export default {
  install(molten) {
    RenderersSetup.install(molten);
    AttributesSetup.install(molten);
    molten.addPlugin('Attribute', {
      id: 'vehicle.yearMakeModel',
      name: 'vehicle.yearMakeModel',
      displayName: 'Vehicle Year, Make & Model',
      valueType: 'string',
      objectType: 'vehicle',
      placement: {
        group: []
      },
      get: obj => {
        const fields = [];
        FIELD_NAMES.forEach(field => {
          if (obj?.data?.[field]) {
            fields.push(obj.data[field]);
          }
        });
        if (fields.length === 0) {
          return null;
        }
        return fields.join(' ');
      }
    });
    molten.addPlugin('Attribute', {
      id: 'vehicle.swatchAndColor',
      name: 'vehicle.swatchAndColor',
      displayName: 'Swatch and Color',
      valueType: 'string',
      objectType: 'vehicle',
      placement: {},
      get: obj => {
        return obj?.data?.color;
      },
      blueprint: {
        field: 'data/color'
      }
    });
    FiltersSetup.install(molten);
  }
};